/**
 * 路由配置
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import NProgress from 'nprogress';
import { getCurrentLang } from '@/lang';

Vue.use(VueRouter);

// 静态路由
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/home'),
  },
  {
    path: '/cgm',
    name: 'CGM',
    component: () => import('@/views/solution/cgm.vue'),
  },
  {
    path: '/downloadsandguides',
    name: 'Download',
    component: () => import('@/views/support/download.vue'),
  },
  {
    path: '/helpCenter',
    name: 'HelpCenter',
    component: () => import('@/views/support/helpCenter.vue'),
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: () => import('@/views/support/faq.vue'),
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('@/views/news'),
  },
  {
    path: '/detail',
    name: 'newsDetail',
    component: () => import('@/views/news/detail.vue'),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/about'),
  },
  {
    path: '/lang',
    name: 'Lang',
    component: () => import('@/views/lang'),
  },
  {
    path: '/faqDetail',
    name: 'faqDetail',
    component: () => import('@/views/support/faqDetail.vue'),
  },
  {
    path: '/index.html',
    redirect: '/',
  },
  {
    path: '*',
    redirect: '/',
  },
];

const router = new VueRouter({
  routes,
  mode: 'history',
});

/* 更新浏览器标题方法 */
const updateTitle = function (route) {
  if (!route?.path?.startsWith('/redirect/')) {
    const names = [];
    if (route?.meta?.title) {
      names.push(route.meta.title);
    }
    const appName = process.env.VUE_APP_NAME;
    if (appName) {
      names.push(appName);
    }
    document.title = names.join(' - ');
  }
};

router.beforeEach((to, from, next) => {
  // 注意：isSelectLang = 是否选择了【区域/国家】，和语言无关
  const isSelectArea = localStorage.getItem('isSelectLang');
  const finalLang = getCurrentLang();

  // 已选区域 + 没有lang参数 → 自动补上（防止无限循环：已补过就跳过）
  if (isSelectArea && finalLang && to.path !== '/lang' && !to.query.lang) {
    return next({
      path: to.path,
      query: { ...to.query, lang: finalLang }, // 👈 修复你写错的变量名
      replace: true,
    });
  }

  // 未选区域 → 跳 /lang 页面
  if (!isSelectArea && to.path !== '/lang') {
    localStorage.setItem('hippoWebLang', finalLang);

    // 拼接正确 redirect，不带 hash
    const redirectQuery = {
      ...to.query,
      lang: finalLang,
    };
    const search = new URLSearchParams(redirectQuery).toString();
    const redirectPath = to.path + (search ? '?' + search : '');

    next({
      path: '/lang',
      query: { redirect: redirectPath },
    });
    return;
  }

  NProgress.start();
  updateTitle(to);
  window.scrollTo(0, 0);
  next();
});

// 已选区域后：自动给URL补上 lang
router.afterEach((to) => {
  setTimeout(() => {
    NProgress.done(true);
  }, 300);
});

// ======================== 全局解决路由重定向报错 ========================
const originalPush = router.push;
router.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    // 完全忽略重定向报错，不影响任何功能
    if (
      err.name === 'NavigationDuplicated' ||
      err.message.includes('Redirected when going from')
    ) {
      return;
    }
    throw err;
  });
};

export default router;
